import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { catchAsync } from 'helpers';

export const updatePassengerById = createAsyncThunk(
  'passengers/updatePassengerById',
  catchAsync(async ({ id, data }, thunkAPI) => {
    const res = await axios.patch(`/passengers/${id}`, data);
    return res.data;
  })
);
